import { Action } from "../../models/Action";
import { clearStepSaleConfig, getStepSaleConfig } from "./saleStepConfigActions";

export interface StepSaleConfigState {
  loading: boolean;
  loaded: boolean;
  error: string | null;
  customOffers: StepSaleConfig[];
}

export interface StepSaleConfig {
  stepName: string;
  stepName_en?: string;
  stepId: string;
  stepDescription: string;
  stepDescription_en?: string;
  showInNavbar: boolean;
  showSimplifiedNavbar: boolean;
  highlightInNavbar: boolean;
  order: number;
  saleSteps: SaleStep[];
}

export enum ProductKinds {
  Pass = "pass",
  Event = "event",
  CalendarSale = "calendarSale",
  Color = "color",
  Shape = "shape",
  AssortGroup = "assortGroup",
  AcademySwimmingLessons = "academySwimmingLessons",
  AcademySwimmingRecruitment = "academySwimmingRecruitment",
  FitnessSchedule = "fitnessSchedule",
}

export interface SaleStep {
  id: string;
  kind: ProductKinds;
  exerciseIds?: string;
  exerciseGroupIds?: string;
  exerciseName?: string;
  assortIds?: string;
  colorIds?: string;
  assortGroupIds?: string;
  shapeIds?: string;
  order: number;
  highlightBanner: boolean;
  bannerLabel: string;
  bannerLabel_en?: string;
  mainPrice: string;
  crossedPrice: string;
  priceLabel: string;
  priceLabel_en?: string;
  highlightedFeature1: string;
  highlightedFeature1_en?: string;
  highlightedFeature2: string;
  highlightedFeature2_en?: string;
  highlightedFeature3: string;
  highlightedFeature3_en?: string;
  loginRequired: boolean;
  alwaysShowHoursToChooseInCalendarSale: boolean;
  alwaysShowTimeToEntryInCalendarSale: boolean;
  showOtherTicketsPool: boolean;
  passSaleVariant: boolean; // to dodałem pod krk aby nie było pre basketa tylko przyciski wybierz
  /** Przeliczenie ceny karnetów na miesiąc i oszczędność względem karnetu miesięcznego. Brak pola = wyłączone. */
  showMonthlyPriceComparison?: boolean;
  displayWithSelectableStartDate: boolean;
  allowToSignByPass: boolean;
  buttonCustomTitle: string;
  buttonCustomTitle_en?: string;
  courtGridScheduleVariant?: boolean;
  weeklyGridScheduleVariant?: boolean;
  toursScheduleVariant: boolean;
  academyVariant?: boolean;
  academyDefaultCourseType?: string;
  academyDefaultExerciseGroup?: string;
  academyDefaultInstructor?: string;
  academyDefaultGroupingVariant?: string;
  dateFromValue?: string;
  dateToValue?: string;
  hideFilters?: boolean;
  /** Jedna grupa zajęciowa, format "db,id". Puste = cały grafik. */
  fitnessDefaultExerciseGroup?: string;
  /** Jedna strefa, format "db,id". Puste = wszystkie strefy. */
  fitnessDefaultZone?: string;
  /** Jeden instruktor, format "db,id". Puste = wszyscy instruktorzy. */
  fitnessDefaultInstructor?: string;
}

const initialState: StepSaleConfigState = {
  loading: false,
  loaded: false,
  error: null,
  customOffers: [],
};

export default function stepSaleConfigReducer(state = initialState, action: Action<any>) {
  switch (action.type) {
    case getStepSaleConfig.pending.toString():
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getStepSaleConfig.fulfilled.toString():
      return {
        ...state,
        loading: false,
        loaded: true,
        customOffers: action.payload.list || state.customOffers,
      };
    case getStepSaleConfig.rejected.toString():
      return {
        ...state,
        loading: false,
        loaded: true,
        error: "Nie udało się załadować konfiguracji własnych podstron",
        customOffers: state.customOffers,
      };
    case clearStepSaleConfig.toString():
      return { ...initialState, customOffers: [] };
    default:
      return state;
  }
}
